
import { Tabs as VueTabs, Tab as VueTab } from 'vue-tabs-component'

export default {
  components: {
    VueTabs,
    VueTab,
  },
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      tabGroupOptions: {
        useUrlFragment: false,
      },
    }
  },
}
